exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.iconBox[data-v-1e25e768] {\n  display: inline-block;\n  width: 15px;\n  height: 15px;\n  background-color: grey;\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 999;\n  opacity: 0.5;\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n.imageBox[data-v-1e25e768] {\n  position: relative;\n  display: inline-block;\n  width: 100px;\n  height: 100px;\n  border: 1px solid #E0E0E0;\n  margin-right: 10px;\n}\n", ""]);

// exports
